import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { PaceAuth0AuthService } from '@evorait/pace-authentication';
import { AuthClientConfig, provideAuth0 } from '@auth0/auth0-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PaceAuth0XIdTokenInterceptor } from './auth0-x-id-token.interceptor';
import { EnvironmentService } from '@evorait/pace-environment';

function auth0Init(environmentService: EnvironmentService, authClientConfig: AuthClientConfig): () => Promise<boolean> {
    const authConfig = environmentService.auth0;
    if (authConfig) {
        const allowedUris = [
            {
                uri: `${environmentService.apiBase}/${environmentService.apiSapProxy}/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environmentService.auth0?.authorizationParams?.audience,
                    },
                },
            },
            {
                uri: `https://*.azurewebsites.net/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environmentService.auth0?.authorizationParams?.audience,
                    },
                },
            },
        ];
        authClientConfig.set({
            ...authConfig,
            httpInterceptor: {
                allowedList: allowedUris,
            },
        });
    }
    return () => new Promise((resolve) => resolve(true));
}

@NgModule({
    imports: [],
    providers: [PaceAuth0AuthService],
    exports: [],
    bootstrap: [],
})
export class PaceAuth0AuthenticationModule {
    public static forRoot(): ModuleWithProviders<PaceAuth0AuthenticationModule> {
        return {
            ngModule: PaceAuth0AuthenticationModule,
            providers: [
                provideAppInitializer(() => {
                    const initializerFn = auth0Init(inject(EnvironmentService), inject(AuthClientConfig));
                    return initializerFn();
                }),
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceAuth0XIdTokenInterceptor,
                    multi: true,
                },
                provideAuth0(),
            ],
        };
    }
}
